<template>
  <component v-if="component" :is="component" :model="props.model" :options="props.options" />
</template>
<script lang="ts" setup>
import type { IContentItem } from '@kontent-ai/delivery-sdk';
import type { LinkedItemOptions } from '~/types/LinkedItemOptions';

const props = defineProps<{ model: IContentItem; options?: LinkedItemOptions }>()
const type = props.model?.system?.type
const component = componentTypeMapper(type)

</script>